import React from 'react';
import { arrayOf, bool, func, node, object, shape, string } from 'prop-types';
import classNames from 'classnames';

import Field, { hasDataInFields } from '../../Field';
import BlockBuilder from '../../BlockBuilder';

import SectionContainer from '../SectionContainer';
import css from './SectionSubcategory.module.css';

// Section component that's able to show article content
// The article content is mainly supposed to be inside a block
const SectionSubcategory = props => {
  const {
    sectionId,
    className,
    rootClassName,
    defaultClasses,
    title,
    description,
    appearance,
    callToAction,
    blocks,
    isInsideContainer,
    options,
  } = props;

  // If external mapping has been included for fields
  // E.g. { h1: { component: MyAwesomeHeader } }
  const fieldComponents = options?.fieldComponents;
  const fieldOptions = { fieldComponents };

  const hasHeaderFields = hasDataInFields([title, description, callToAction], fieldOptions);
  const hasBlocks = blocks?.length > 0;

  const listCategories = blocks.filter(b => b.blockName == 'subcategory-menu');
  const itemsCategories = blocks.filter(b => b.blockName == 'subcategory-item');
  const imageCategories = blocks.filter(b => b.blockName == 'subcategory-image');

  return (
    <SectionContainer
      id={sectionId}
      className={className}
      rootClassName={rootClassName}
      appearance={appearance}
      options={fieldOptions}
    >
      {hasHeaderFields ? (
        <header className={defaultClasses.sectionDetails}>
          <Field data={title} className={defaultClasses.title} options={fieldOptions} />
          <Field data={description} className={defaultClasses.description} options={fieldOptions} />
          <Field data={callToAction} className={defaultClasses.ctaButton} options={fieldOptions} />
        </header>
      ) : null}
      <div className={css.subcategoryContainer}>
        <div className={css.subcategoryList}>
          {listCategories.length ? (
            <BlockBuilder
              blocks={listCategories}
              sectionId={sectionId}
              ctaButtonClass={defaultClasses.ctaButton}
              options={options}
            />
          ) : null}
        </div>
        <div className={css.subcategoryItems}>
          {itemsCategories.length ? (
            <BlockBuilder
              blocks={itemsCategories}
              sectionId={sectionId}
              ctaButtonClass={defaultClasses.ctaButton}
              options={options}
            />
          ) : null}
        </div>
        <div className={css.subcategoryImage}>
          {imageCategories.length ? (
            <BlockBuilder
              blocks={imageCategories}
              sectionId={sectionId}
              ctaButtonClass={defaultClasses.ctaButton}
              options={options}
            />
          ) : null}
        </div>
      </div>
    </SectionContainer>
  );
};

const propTypeOption = shape({
  fieldComponents: shape({ component: node, pickValidProps: func }),
});

SectionSubcategory.defaultProps = {
  className: null,
  rootClassName: null,
  defaultClasses: null,
  textClassName: null,
  title: null,
  description: null,
  appearance: null,
  callToAction: null,
  blocks: [],
  isInsideContainer: false,
  options: null,
};

SectionSubcategory.propTypes = {
  sectionId: string.isRequired,
  className: string,
  rootClassName: string,
  defaultClasses: shape({
    sectionDetails: string,
    title: string,
    description: string,
    ctaButton: string,
  }),
  title: object,
  description: object,
  appearance: object,
  callToAction: object,
  blocks: arrayOf(object),
  isInsideContainer: bool,
  options: propTypeOption,
};

export default SectionSubcategory;
